import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { APPOINTMENT_BOOKING_START_ROUTE } from '../../appointment/appointment-booking-state.service';
import { ConfigService } from '../../core/config.service';
import { Task, VisitFollowUpOrderContent } from '../../shared/task';

interface TaskWithVisitFollowUpOrderContent extends Task {
  content: VisitFollowUpOrderContent;
}

@Component({
  selector: 'om-visit-follow-up-order-details',
  templateUrl: './visit-follow-up-order-details.component.html',
  styleUrls: ['./visit-follow-up-order-details.component.scss', '../_shared-task-details.scss'],
})
export class VisitFollowUpOrderDetailsComponent {
  @Input() task: TaskWithVisitFollowUpOrderContent;

  constructor(public config: ConfigService, private router: Router) {}

  startBookingAppointmentWithTask() {
    const taskId = this.task.id;
    this.router.navigate([APPOINTMENT_BOOKING_START_ROUTE], { queryParams: { taskId } });
  }
}
